import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TReducer, AclOperation } from './types';

export const initialState: TReducer = {
	userName: '',
	userEmail: '',
	grpId: '',
	role: [],
	settings: null,
	operations: [],
	currentWorkspace: null,
	allTenentList: [],
};

const slice = createSlice({
	initialState,
	name: `user`,
	reducers: {
		updateUserInfo(
			state,
			{
				payload: { userName, userEmail, grpId, settings, webAppSettings, operations, allTenentList, role },
			}: PayloadAction<{
				userName?: string;
				userEmail?: string;
				grpId?: string;
				settings?: Record<string, unknown> | null;
				webAppSettings?: Record<string, unknown>;
				operations?: AclOperation[];
				allTenentList?: Array<{ grpId: string; [key: string]: unknown }>;
				role?: string[];
			}>
		) {
			return {
				...state,
				userName: userName || state.userName,
				userEmail: userEmail || state.userEmail,
				grpId: grpId || state.grpId,
				settings: settings || state.settings,
				operations: operations || state.operations,
				webAppSettings: webAppSettings || state.webAppSettings,
				allTenentList: allTenentList || state.allTenentList,
				role: role || state.role,
			};
		},
		updateGrpId(state, { payload: { grpId } }: PayloadAction<{ grpId: string }>) {
			return {
				...state,
				grpId: grpId,
			};
		},
		updateAllTenentList(
			state,
			{ payload: { allTenentList } }: PayloadAction<{ allTenentList: Array<{ grpId: string; [key: string]: unknown }> }>
		) {
			return {
				...state,
				allTenentList: allTenentList,
			};
		},
		updateWorkspace(
			state,
			{ payload: { workspaceProps } }: PayloadAction<{ workspaceProps: Record<string, unknown> | null }>
		) {
			return {
				...state,
				currentWorkspace: workspaceProps,
			};
		},
	},
});

export default slice;

export const { updateUserInfo, updateWorkspace, updateAllTenentList, updateGrpId } = slice.actions;
